import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const solicitacoesEmbarcadorRepository = createRepository({
  path: 'solicitacoesEmbarcador',
  restApi,
  queryTransform: {
    motorista: query.ilike('motorista'),
    cpf: query.like('cpf'),
    placa: query.ilike('placa'),
    mercadoria: query.ilike('mercadoria'),
    nomeEmbarcador: query.ilike('nomeEmbarcador'),
    status: query.eq('status'),
    responsavelId: query.eq('responsavelId'),
    createdAt: query.gte('createdAt'),
    dataTermino: query.lte('dataTermino'),
    ...paginate
  }
})

solicitacoesEmbarcadorRepository.createSolicitacao = (data, files) => {
  const formData = new FormData()
  formData.append('cnh', files.cnh)
  formData.append('foto', files.foto)
  for (let i = 0; i < files.crlvs.length; i++) {
    formData.append(`crlv_${i}`, files.crlvs[i])
  }
  formData.append('comprovanteEndereco', files.comprovanteEndereco)
  formData.append('contratoAgregado', files.contratoAgregado)
  formData.append('grExternaFile', files.grExternaFile)
  formData.append('contratoArrendamento', files.contratoArrendamento)
  formData.append('comprovanteViagens', files.comprovanteViagens)
  formData.append('data', JSON.stringify(data))
  return restApi.post('solicitacoesEmbarcador', formData, {
    header: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
}

solicitacoesEmbarcadorRepository.getDadosParaNenovacao = filter => {
  return restApi.get('solicitacoesEmbarcador/get-dados-renovacao', { filter })
}

export default solicitacoesEmbarcadorRepository
